import React from "react";
import { buildStripeCreditPurchaseUrl } from "./publicAccountSession";

export default function PublicAccountSummary({ user, balances, onLogout, loggingOut, showAccountLink = true }) {
  if (!user) return null;
  const purchaseUrl = buildStripeCreditPurchaseUrl(user.user_email);
  return <section style={{ background: "#f8fafc", border: "1px solid #dbe3ee", borderRadius: 10, padding: 12, marginBottom: 16 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
      <strong>Signed in as {user.masked_email || "verified user"}</strong>
      <button type="button" onClick={onLogout} disabled={loggingOut}>{loggingOut ? "Logging out…" : "Logout"}</button>
    </div>
    <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginTop: 8, fontSize: 14 }}>
      <span>Subscription: {balances?.subscription_remaining ?? 0}</span>
      <span>Promotional: {balances?.promotional_credit_balance ?? 0}</span>
      <span>Paid: {balances?.paid_credit_balance ?? 0}</span>
    </div>
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 10, marginTop: 10 }}>
      {showAccountLink ? <a href="/public-dashboard-embed" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", background: "#fff", color: "#334155", border: "1px solid #cbd5e1", borderRadius: 7, padding: "7px 11px", fontSize: 14, fontWeight: 700, textDecoration: "none" }}>My Account</a> : null}
      {purchaseUrl ? <>
        <a href={purchaseUrl} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", background: "#3f51b5", color: "#fff", borderRadius: 7, padding: "7px 11px", fontSize: 14, fontWeight: 700, textDecoration: "none" }}>Buy AI Credits</a>
        <span style={{ color: "#64748b", fontSize: 13 }}>Payment will be linked to your verified email.</span>
      </> : null}
    </div>
  </section>;
}
